import { render, staticRenderFns } from "./ViewQuotation.vue?vue&type=template&id=28bbf308&"
import script from "./ViewQuotation.vue?vue&type=script&lang=js&"
export * from "./ViewQuotation.vue?vue&type=script&lang=js&"
import style0 from "./ViewQuotation.vue?vue&type=style&index=0&id=28bbf308&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports